import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'
import { IApplicationState } from '@Site/rootReducer'

import Popup from '@SiteComponents/Popup'
import EditLabelForm from '@SiteComponents/EditLabelForm'

import {
  renameLabel,
} from '@SiteModules/Label/actions'

import {
  IRenameLabelPayload,
} from '@SiteModules/Label/types'

import './RenameLabelPopup.scss'

interface RenameLabelPopupProps {
  readonly editingLabelId: number
  readonly editingLabelCaption: string
  closePopup(): void
  renameLabel(payload: IRenameLabelPayload): void
}

interface RenameLabelPopupState {}

class RenameLabelPopup extends React.Component<RenameLabelPopupProps, RenameLabelPopupState> {
  render() {
    const {
      editingLabelId,
      editingLabelCaption,
      closePopup,
    } = this.props

    return (
      <Popup
        className="EditLabelPopup"
        closePopup={closePopup}
      >
        <EditLabelForm
          labelId={editingLabelId}
          caption={editingLabelCaption}
          closePopup={closePopup}
          renameLabel={this.props.renameLabel}
        />
      </Popup>
    )
  }
}

function mapStateToProps(state: IApplicationState) {
  const { editingLabelId, editingLabelCaption } = state.popup

  return {
    editingLabelId,
    editingLabelCaption,
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action>) {
  return bindActionCreators({
    renameLabel,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(RenameLabelPopup)
